import { Box, Chip, Stack, Tooltip } from '@mui/material';
import { TimeUnit } from 'generated/graphql';

interface TimePeriodProps {
  value?: TimeUnit;
  onChange: (value: TimeUnit) => void;
  disable?: {
    [TimeUnit.Day]?: boolean;
    [TimeUnit.Week]?: boolean;
    [TimeUnit.Month]?: boolean;
  };
}

export function TimePeriod({ value, onChange, disable = {} }: TimePeriodProps) {
  const renderChip = (
    aggregatePeriod: TimeUnit.Day | TimeUnit.Week | TimeUnit.Month,
    label: string,
  ) => {
    return (
      <Tooltip
        arrow
        placement="top"
        title={
          disable[aggregatePeriod]
            ? `The query duration is too small or large for ${label} analysis`
            : ''
        }
      >
        <Box>
          <Chip
            label={label}
            variant="outlined"
            size="small"
            sx={{ minWidth: 80 }}
            color={value === aggregatePeriod ? 'primary' : 'default'}
            onClick={() => onChange(aggregatePeriod)}
            disabled={disable[aggregatePeriod]}
          />
        </Box>
      </Tooltip>
    );
  };

  return (
    <Stack direction="row" spacing={1}>
      {renderChip(TimeUnit.Day, 'Daily')}
      {renderChip(TimeUnit.Week, 'Weekly')}
      {renderChip(TimeUnit.Month, 'Monthly')}
    </Stack>
  );
}
